
/**
 * Angular import.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
/**
 * Services import.
 */
import { DataStorageService } from './../../dataservices/data-storage.service';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from './../common-functions/fun-collection.service';
/**
 * Directive imports.
 */
import { ButtonDirective } from './../../directives/ga.directive';
/**
 * Constant imports.
 */
import { PRODUCT_TYPE_CONSTANT } from './../../constants/app.constants';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

/**
 * Pdf view component
 */
@Component({
  selector: 'app-pdf-view',
  templateUrl: './pdf-view.component.html',
  styleUrls: ['./pdf-view.component.scss']
})
export class PdfViewComponent implements OnInit, OnDestroy  {
  @Input() pdfscr: string | Uint8Array | null;
  @Input() idx;
  @Input() useractivity;
  @Input() show_all_page = false;
  @Input() preview_url: string;
  @Input() productId: number;
  @Input() productType: number;

  public is_loading = false;
  public sanitizedPdfSrc: SafeResourceUrl;

  /**
   * Used to store date object.
   */
  public dateObj = new Date();

  /**
   *  Page name.
   */
  public page_from = this.mls.googleEventText.drug_sample_detail.key10;

  /**
   * Drug type from constants.
   */
  public productTypeConstant = PRODUCT_TYPE_CONSTANT;


  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   *  drug session time object.
   */
  public sessiontime = { 'start_time': '', 'end_time': '' };

  /**
   * Necessary instances.
   */
  constructor(public mls: NewLanguageService,
              public dss: DataStorageService,
              private directive_ser: ButtonDirective,
              public fcs: FunCollectionService,private sanitizer: DomSanitizer) {

  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.is_loading = true;
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy(): void {

    this.is_loading = false;

    if (this.productType === this.productTypeConstant.DRUG) {

      const date = new Date();
      this.sessiontime.end_time = date.getTime().toString();

      this.directive_ser.productDetailEvent(Object.assign({}, this.sessiontime),
        this.mls.googleEventText.drug_sample_detail.key10, this.productType, this.productId,

        this.page_from, this.dss.user_profile_data.profile.track_id);
    }
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }


  

  /**
   * call BackFn
   */
  callBackFn(): void {
    this.is_loading = false;
    
  if (this.productType === this.productTypeConstant.DRUG) {
      this.analyticsOnVisit();
    }
  }
  onPdfError(event: any) : void {
    console.error("PDF Load Error:", event);
  }
  

  /**
   * analytics on page Visit.
   */
  analyticsOnVisit(): void {
    const d = new Date();
    this.sessiontime.start_time = d.getTime().toString();

    this.fcs.IsUserActiveOnApp(this.page_from);

    this.subscriptions.add(this.dss.is_browser_tab_active_action.subscribe(data => {

      if (data.page_from === this.page_from && data.is_visible === 0) {

        const date = new Date();
        this.sessiontime.end_time = date.getTime().toString();
        this.directive_ser.productDetailEvent(Object.assign({}, this.sessiontime),
          this.mls.googleEventText.drug_sample_detail.key10,
          this.productType,
          this.productId,
          this.page_from, this.dss.user_profile_data.profile.track_id);
      } else if (data.page_from === this.page_from && data.is_visible === 1) {

        setTimeout(() => {
          const date = new Date();
          this.sessiontime.start_time = date.getTime().toString();
        }, 1000);
      }
    }));


  }

}
